export const statsSet = 140;
export const allPatches = [15110, 15100, 15090, 15080, 15071, 15070];
export const lastPatch = allPatches[0];
export const REVIQ_THRESHOLD = 0;
